const PERSISTED_STATE_KEY = 'persistedStateKey';

export const isLocalStorageSupported = (() => {
  try {
    const key = '__localStorageTestKey';

    localStorage.setItem(key, key);
    localStorage.removeItem(key);

    return true;
  } catch (err) {
    return false;
  }
})();

export const get = () => {
  try {
    return JSON.parse(localStorage.getItem(PERSISTED_STATE_KEY));
  } catch (e) {
    // ignore all localStorage & string => object parsing problems
  }
  return undefined;
};

export const set = (state) => {
  try {
    localStorage.setItem(PERSISTED_STATE_KEY, JSON.stringify(state));
  } catch (e) {
    // ignore all localStorage & object => string conversion problems
  }
};
